module.exports = __webpack_public_path__ + "img/MicroForum.1202c1c3.svg";